import { styled } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

export const ApproachMenuInfoSection = styled('li')(({ theme }) => ({
  boxSizing: 'border-box',
  cursor: 'default',
  display: 'grid',
  gap: theme.spacing(0.75),
  listStyle: 'none',
  margin: 0,
  padding: theme.spacing(1),
  width: '100%',
}));

export const ApproachMenuInfoItem = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

export const ApproachMenuInfoLabel = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 700,
  letterSpacing: '0.02em',
  lineHeight: theme.typography.caption.lineHeight,
}));

export const ApproachMenuInfoValue = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 400,
  lineHeight: theme.typography.caption.lineHeight,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const useStyles = makeStyles((theme: ITheme) => ({
  gpcInUse: {
    color: theme.palette.text.secondary,
    fontSize: '1.25em',
    marginLeft: theme.spacing(1),
  },
  isBenchmarkCheckBox: {
    padding: 0,
    marginLeft: theme.spacing(1),
  },
}));
